import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
//@ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import { Theme, GetActualThemesRequest } from '@yandex-int/k-common/typings';
import { SUBJECTS_SLUGS_TYPE } from 'platform-components/src/typings';

import * as constants from './constants';

export const getRootThemesRequest = (subject: SUBJECTS_SLUGS_TYPE) =>
    <const>{
        type: constants.GET_ROOT_THEMES_REQUEST,
        subject,
    };

export const getRootThemesSuccess = (subject: SUBJECTS_SLUGS_TYPE, themes: Array<Theme>) =>
    <const>{
        type: constants.GET_ROOT_THEMES_SUCCESS,
        subject,
        themes,
    };

export const getRootThemesError = (subject: SUBJECTS_SLUGS_TYPE) =>
    <const>{
        type: constants.GET_ROOT_THEMES_ERROR,
        subject,
    };

export const getThemesTreeRequest = (subject: SUBJECTS_SLUGS_TYPE, themeId: number, depth?: number) =>
    <const>{
        type: constants.GET_THEMES_TREE_REQUEST,
        subject,
        themeId,
        depth,
    };

export const getThemesTreeSuccess = (
    subject: SUBJECTS_SLUGS_TYPE,
    themeId: number,
    themes: Array<Theme>,
    rootId: number
) =>
    <const>{
        type: constants.GET_THEMES_TREE_SUCCESS,
        subject,
        themeId,
        themes,
        rootId,
    };

export const getThemesTreeError = (subject: SUBJECTS_SLUGS_TYPE, themeId: number) =>
    <const>{
        type: constants.GET_THEMES_TREE_ERROR,
        subject,
        themeId,
    };

export const setThemesTreeLoadingStatus = (subject: SUBJECTS_SLUGS_TYPE, themeId: number, status: LOADING_STATUSES) =>
    <const>{
        type: constants.SET_THEMES_TREE_LOADING_STATUS,
        subject,
        status,
        themeId,
    };

export const getActualThemesRequest = (params: GetActualThemesRequest) =>
    <const>{
        type: constants.GET_ACTUAL_THEMES_REQUEST,
        ...params,
    };

export const getActualThemesSuccess = (subject: SUBJECTS_SLUGS, themes: Array<Theme>, courseId: number) =>
    <const>{
        type: constants.GET_ACTUAL_THEMES_SUCCESS,
        subject,
        themes,
        courseId,
    };

export const getActualThemesError = (subject: SUBJECTS_SLUGS, courseId: number) =>
    <const>{
        type: constants.GET_ACTUAL_THEMES_ERROR,
        subject,
        courseId,
    };
